<div id="mediakit">
  <div id="background">
    <div class="linear"></div>
    <img src="assets/images/mediakit_top.png" alt="MediaKit top image" />
  </div>

  <div class="bloc">
    <h1>{{ 'mediakit.title' | translate }}</h1>
    <p class="subTitle">{{ 'mediakit.subtitle' | translate }}</p>

    <div class="content">
      <div class="folders">
        <div *ngFor="let item of driveStructure">
          <app-folder [folder]="item" [index]="0"></app-folder>
        </div>
      </div>

      <div class="filesBloc">
        <div class="header">
          <h3>{{ title }}</h3>
          <div class="btnGroup" *ngIf="!mobileMode">
            <button [ngClass]="{'active' : listActive}" (click)="changeStyle('list')"><img src="./assets/images/media-kit/list{{ listActive ? '-active' : '' }}.svg" alt=""></button>
            <button [ngClass]="{'active' : gridActive}" (click)="changeStyle('grid')"><img src="./assets/images/media-kit/grid{{ gridActive ? '-active' : '' }}.svg" alt=""></button>
          </div>
        </div>

        <div class="filesList">

          <div class="grid" *ngIf="gridActive && content && content[0]">

            <div *ngFor="let item of content" class="grid-card" (click)="dowloadFile(item)">
              <div class="image" *ngIf="getIcon(item) !== 'video'">
                <img *ngIf="item.data.hasThumbnail && item.data.thumbnailLink" [src]='item.data.thumbnailLink' [alt]="item.data.name">
              </div>
              <div class="noimage" *ngIf="getIcon(item) === 'video'">
                <div class="circle">
                  <img src="./assets/images/media-kit/video_big.svg" alt="video">
                </div>
              </div>
              <div class="content">
                <p class="title">{{ item.data.name.split('.')[0].toLowerCase() }}</p>
                <div class="infos">
                  <p>{{ item.data.size | formatSize }}</p>
                  <p>{{ item.data.modifiedTime | date: 'dd/MM/yyyy' }}</p>
                </div>
              </div>
            </div>

          </div>
          <table *ngIf="listActive">
            <thead style="border-bottom: 1px solid white;">
              <th style="text-align: center;">{{ 'mediakit.table.type' | translate }}</th>
              <th>{{ 'mediakit.table.filename' | translate }}</th>
              <th *ngIf="!mobileMode">{{ 'mediakit.table.date' | translate }}</th>
              <th>{{ 'mediakit.table.size' | translate }}</th>
              <th style="text-align: center;">{{ 'mediakit.table.download' | translate }}</th>
            </thead>
            <tbody *ngIf="content && content[0]">
              <tr *ngFor="let item of content">
                <td style="text-align: center;"><img src="./assets/images/media-kit/{{ getIcon(item) }}.svg" alt=""></td>
                <td>{{ item.data.name.split('.')[0].toLowerCase() }}</td>
                <td *ngIf="!mobileMode">{{ item.data.modifiedTime | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.data.size | formatSize }}</td>
                <td style="text-align: center" (click)="dowloadFile(item)">
                  <img style="cursor: pointer;" src="./assets/images/media-kit/dl.svg" alt="">
                </td>
              </tr>
            </tbody>
          </table>

          <div class="pagination">
            <div *ngFor='let in of [].constructor(maxPage) ;let i = index'>
              <div class="pagination-el" [ngClass]="{'active': i === index}" (click)="paginate(i)">
                <span >{{i + 1}}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
